export enum InvoiceActionResultType {
  Success = 1,
  PartialSuccess = 2,
  Failure = 3,
}
